// Shared class strings for the OpusOS design system (industrial slate + indigo).
export const ui = {
  pageHeader: "text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-100 font-h",
  sectionHeader: "text-lg font-bold tracking-tight text-slate-200 font-h",
  cardTitle: "text-base font-semibold text-slate-200 font-h",
  muted: "text-sm text-slate-400",
  card: "bg-slate-900/60 border border-slate-800/80 rounded-xl shadow-sm backdrop-blur-sm",
  label: "block text-xs font-semibold uppercase tracking-wider text-slate-300 mb-1.5 font-h",
  input:
    "w-full bg-slate-950 border border-slate-800 rounded-lg px-3.5 py-2.5 text-sm text-slate-100 placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-colors",
  textarea:
    "w-full bg-slate-950 border border-slate-800 rounded-lg p-3 text-sm text-slate-100 placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-colors resize-y min-h-[100px]",
  btnPrimary:
    "inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-indigo-600 text-white font-semibold rounded-lg text-sm hover:bg-indigo-500 transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed font-h",
  btnGhost:
    "inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-slate-800 text-slate-200 font-medium rounded-lg text-sm hover:bg-slate-700 transition-colors disabled:opacity-50 font-h",
  btnDanger:
    "inline-flex items-center justify-center gap-2 px-3 py-2 bg-rose-500/15 border border-rose-500/40 text-rose-300 font-medium rounded-lg text-sm hover:bg-rose-500/25 transition-colors font-h",
  badge:
    "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-mono tracking-wider uppercase font-medium border",
};

export const statusStyle = {
  draft: "bg-slate-800/80 border-slate-700 text-slate-300",
  preview: "bg-amber-950/60 border-amber-500/40 text-amber-300",
  live: "bg-emerald-950/60 border-emerald-500/30 text-emerald-300",
  failed: "bg-rose-950/60 border-rose-500/40 text-rose-300",
  running: "bg-sky-950/60 border-sky-500/40 text-sky-300",
};
